import { render, staticRenderFns } from "./NameBasic.vue?vue&type=template&id=65323fc8"
import script from "./NameBasic.vue?vue&type=script&lang=js"
export * from "./NameBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports